import { FC } from 'react';
import ProDrawer, { DrawerProps } from './drawer';

export type IDrawerComponent = FC<DrawerProps>;

const TransDrawer = ProDrawer as IDrawerComponent;

export default TransDrawer;
